// Copyright (c) 2021 WiseTime. All rights reserved.

// @generated by protoc-gen-es v2.11.0 with parameter "target=ts"
// @generated from file legebill/type/narrative_type.proto (package legebill.type, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc } from "@bufbuild/protobuf/codegenv2";

/**
 * Describes the file legebill/type/narrative_type.proto.
 */
export const file_legebill_type_narrative_type: GenFile = /*@__PURE__*/
  fileDesc("CiJsZWdlYmlsbC90eXBlL25hcnJhdGl2ZV90eXBlLnByb3RvEg1sZWdlYmlsbC50eXBlKmwKDU5hcnJhdGl2ZVR5cGUSHgoaTkFSUkFUSVZFX1RZUEVfVU5TUEVDSUZJRUQQABISCg5OQVJSQVRJVkVfT05MWRABEicKI05BUlJBVElWRV9BTkRfVElNRV9ST1dfREVTQ1JJUFRJT05TEAJCLQoVY29tLmxlZ2ViaWxsLmFwaS50eXBlQhJOYXJyYXRpdmVUeXBlUHJvdG9QAWIGcHJvdG8z");

/**
 * @generated from enum legebill.type.NarrativeType
 */
export enum NarrativeType {
  /**
   * @generated from enum value: NARRATIVE_TYPE_UNSPECIFIED = 0;
   */
  NARRATIVE_TYPE_UNSPECIFIED = 0,

  /**
   * @generated from enum value: NARRATIVE_ONLY = 1;
   */
  NARRATIVE_ONLY = 1,

  /**
   * @generated from enum value: NARRATIVE_AND_TIME_ROW_DESCRIPTIONS = 2;
   */
  NARRATIVE_AND_TIME_ROW_DESCRIPTIONS = 2,
}

/**
 * Describes the enum legebill.type.NarrativeType.
 */
export const NarrativeTypeSchema: GenEnum<NarrativeType> = /*@__PURE__*/
  enumDesc(file_legebill_type_narrative_type, 0);

